// 积分接口
import $http from '@/resource';

const $api = {};

/**
 *积分录入
 *
 *  * @method POST
 *
 * @param {Object} data 参数
 *
 * @returns {Promise<any>}
 */
$api.addIntegral = function(data) {
    const url = 'integral/add';
    const promise = new Promise(function(resolve, reject){
        $http.post(url, data).then(function (response) {
            if (response.code == 200) {
                resolve(response);
            } else {
                reject(response);
            }
        });
    });
    return promise;
}

/**
 * 获取企业积分
 *
 * @method GET
 *
 * @param {Object} listData 搜索条件
 *
 * @returns {Promise<*>}
 *
 * @url /integral
 */
$api.getCompanyIntegralList = async (listData) => {
    let url = `/integral`;
    return await $http.get(url,{ params: listData });
};




export default $api;



// WEBPACK FOOTER //
// ./src/service/enterprise/integral.js